// extracted by mini-css-extract-plugin
export default {"modal":"privacy-policy-modal_modal__IRGt+","content":"privacy-policy-modal_content__EQPEZ","description":"privacy-policy-modal_description__LGzuW"};